import App from "@/App.vue";

export default [
  {
    path: "/grupo-economico",
    name: "economic_group",
    component: App,
    redirect: { name: "economic_group list" },
    children: [
      {
        path: "",
        name: "economic_group list",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EconomicGroupList.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Grupo Econômico",
              disabled: false
            }
          ],
          requiresAuth: true,
          displayName: "Lista Grupo Econômico - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      },
      {
        path: ":groupId/",
        name: "economic_group view",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EconomicGroup.vue"),
        meta: {
          requiresAuth: true,
          displayName: "Grupo Econômico - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      },
      {
        path: ":groupId/tomadores/:companyId",
        name: "economic_group company",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Company.vue"),
        meta: {
          requiresAuth: true,
          displayName: "Grupo Econômico - Tomador - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      }
    ]
  },
  {
    path: "/novo-grupo-economico",
    name: "add economic_group",
    component: App,
    redirect: { name: "new economic_group" },
    children: [
      {
        path: "",
        name: "new economic_group",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewEconomicGroup.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Adicionar Grupo Econômico",
              disabled: false,
              link: true,
              to: { name: "economic_group list" }
            }
          ],
          requiresAuth: true,
          displayName: "Lockton - Grupo Econômico - Tomador",
          permissionRoute: "criar_grupo_economico"
        }
      }
    ]
  },
  {
    path: "/grupo-economico/:groupId/adicionar-tomador-ou-filial",
    name: "choose new economic_group company",
    component: App,
    redirect: { name: "choose economic_group company subsidiary" },
    children: [
      {
        path: "",
        name: "choose economic_group company subsidiary",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewTomadorOrSubsidiary.vue"
          ),
        meta: {
          requiresAuth: true,
          displayName:
            "Grupo Econômico - Adicionar Tomador ou Filial - Lockton",
          permissionRoute: "criar_grupo_economico"
        }
      }
    ]
  },
  {
    path: "/grupo-economico/:groupId/novo-tomador",
    name: "add economic_group company",
    component: App,
    redirect: { name: "new economic_group company" },
    children: [
      {
        path: "",
        name: "new economic_group company",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewCompany.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Adicionar Tomador",
              disabled: false,
              link: true,
              to: { name: "add economic_group" }
            }
          ],
          requiresAuth: true,
          displayName: "Grupo Econômico - Novo Tomador - Lockton",
          permissionRoute: "criar_grupo_economico"
        }
      }
    ]
  },
  {
    path: "/grupo-economico/:groupId/nova-filial",
    name: "add economic_group subsidiary",
    component: App,
    redirect: { name: "new economic_group subsidiary" },
    children: [
      {
        path: "",
        name: "new economic_group subsidiary",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewCompany.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Adicionar Tomador Filial",
              disabled: false,
              link: true,
              to: { name: "add economic_group" }
            }
          ],
          requiresAuth: true,
          displayName: "Grupo Econômico - Nova Filial - Lockton",
          permissionRoute: "criar_grupo_economico"
        }
      }
    ]
  },
  {
    path: "/grupo-economico/:groupId/tomadores-e-filiais",
    name: "economic_group companies",
    component: App,
    redirect: { name: "economic_group companies list" },
    children: [
      {
        path: "",
        name: "economic_group companies list",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/CompaniesList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Grupo Econômico",
              disabled: false,
              link: false,
              to: { name: "economic_group" }
            }
          ],
          requiresAuth: true,
          displayName: "Grupo Econômico - Tomadores e Filiais - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      }
    ]
  },
  {
    path: "/grupo-economico/:groupId/limite-de-credito",
    name: "economic_group credit_limit",
    component: App,
    redirect: { name: "economic_group credit_limit list" },
    children: [
      {
        path: "",
        name: "economic_group credit_limit list",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/CreditLimitList.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Grupo Econômico",
              disabled: false,
              link: false,
              to: { name: "economic_group" }
            }
          ],
          requiresAuth: true,
          displayName: "Grupo Econômico - Limite de Crédito - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      },
      {
        path: "nova-consulta",
        name: "economic_group credit_limit new",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ConsultMarket.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Grupo Econômico",
              disabled: false,
              link: false,
              to: { name: "economic_group" }
            }
          ],
          requiresAuth: true,
          displayName:
            "Grupo Econômico - Nova Consulta de Limite de Crédito - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      },
      {
        path: ":consultId",
        name: "economic_group credit_limit consult",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ConfigureConsultLimit.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Grupo Econômico",
              disabled: false,
              link: false,
              to: { name: "economic_group" }
            }
          ],
          requiresAuth: true,
          displayName:
            "Grupo Econômico - Situação da Consulta de Limite de Crédito - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      },
      {
        path: ":consultId/historico",
        name: "economic_group credit_limit historic",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/HistoricLimit.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Seguradora ",
              disabled: false,
              link: true,
              to: { name: "economic_group credit_limit consult" }
            }
          ],
          requiresAuth: true,
          displayName:
            "Grupo Econômico - Histórico do Limite de Crédito - Lockton",
          permissionRoute: "visualizar_grupo_economico"
        }
      }
    ]
  }
];
